// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NyX8e","header__toolbar":"styles_header__toolbar__3hF9y"};